import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4960391a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "language" }
const _hoisted_2 = { class: "language__current-name" }
const _hoisted_3 = {
  key: 0,
  class: "language__list"
}
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = { class: "language__list-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LanguageIcon = _resolveComponent("LanguageIcon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("button", {
      class: "language__current",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal = !_ctx.modal))
    }, [
      _createVNode(_component_LanguageIcon, {
        lang: _ctx.$i18n.locale
      }, null, 8, ["lang"]),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.languages.find((e) => e.lang === _ctx.$i18n.locale)?.name || ""), 1)
    ]),
    (_ctx.modal)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language) => {
            return (_openBlock(), _createElementBlock("li", {
              key: language.lang
            }, [
              _createElementVNode("button", {
                class: "language__button",
                title: language.name,
                onClick: () => _ctx.changeLanguage(language)
              }, [
                _createVNode(_component_LanguageIcon, {
                  lang: language.lang
                }, null, 8, ["lang"]),
                _createElementVNode("span", _hoisted_5, _toDisplayString(language.name), 1)
              ], 8, _hoisted_4)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}